import { Query } from "../../interfaces";
import ConnectionClient from "../../shared/api-client";

export const getAnalytics = async (
  collection: string,
  query: Query,
  page: number = 1,
  limit: number = 10
) => {
  const client = new ConnectionClient();
  const result = await client.api.get(
    `${
      process.env.REACT_APP_API_HOST
    }/analytics/connections-request?page=${page}&limit=${limit}&${Object.values(
      query.filter
    ).join("")}&meta=filter_count`
  );
  return result.data;
};
